import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import Select from "react-select";
import UploadPhoto from "../../../Global/UploadPhoto";
import useBulkUpload from "./useBulkUpload";

const BulkUpload = ({ refetch, handleClose }) => {
  const {
    formik,
    uploadTypeOptions,
    itemTypeOptions,
    getFieldError,
    handleUploadTypeChange,
    handleItemTypeChange,
    handleImagesChange,
    handleImagesDelete,
    handleZipChange,
  } = useBulkUpload({ refetch, handleClose });

  const isImageMode = formik.values.upload_type === "1";

  return (
    <div className="input-wrap pro-mb-4">
      <div className="input-wrap pro-mb-4">
        <label className="pro-font-sm pro-mb-1 pro-fw-medium">
          Upload Type*
        </label>
        <Select
          name="upload_type"
          placeholder="Select Upload Type"
          className={`pro-input lg ${getFieldError("upload_type") && " error"}`}
          classNamePrefix="pro-input"
          options={uploadTypeOptions}
          getOptionLabel={(option) => option?.label}
          getOptionValue={(option) => option?.value}
          value={uploadTypeOptions?.filter(
            (o) => o.value === formik.values.upload_type,
          )}
          onChange={handleUploadTypeChange}
          onBlur={() => formik.setFieldTouched("upload_type", true)}
          menuPlacement="auto"
        />
        {getFieldError("upload_type") && (
          <span className="error-text">{getFieldError("upload_type")}</span>
        )}
      </div>

      <div className="input-wrap pro-mb-4">
        <label className="pro-font-sm pro-mb-1 pro-fw-medium">Item Type*</label>
        <Select
          name="item_type"
          placeholder="Select Item Type"
          isClearable
          className={`pro-input lg ${getFieldError("item_type") && " error"}`}
          classNamePrefix="pro-input"
          options={itemTypeOptions}
          getOptionLabel={(option) => option?.name}
          getOptionValue={(option) => option?._id}
          value={itemTypeOptions?.filter(
            (o) => o._id === formik.values.item_type,
          )}
          onChange={handleItemTypeChange}
          onBlur={() => formik.setFieldTouched("item_type", true)}
          menuPlacement="auto"
        />
        {getFieldError("item_type") && (
          <span className="error-text">{getFieldError("item_type")}</span>
        )}
      </div>

      {isImageMode && (
        <div className="input-wrap pro-mb-4">
          <Input
            label={"Folder Name*"}
            type="text"
            id="folder_name"
            name="folder_name"
            className={`pro-input lg ${
              getFieldError("folder_name") && " error"
            }`}
            {...formik.getFieldProps("folder_name")}
            error={getFieldError("folder_name")}
            errorMessage={getFieldError("folder_name")}
          />
        </div>
      )}

      <div className="input-wrap pro-mb-4">
        <Input
          label={"Certificate Start*"}
          type="text"
          id="certificate_start"
          name="certificate_start"
          className={`pro-input lg ${
            getFieldError("certificate_start") && " error"
          }`}
          {...formik.getFieldProps("certificate_start")}
          error={getFieldError("certificate_start")}
          errorMessage={getFieldError("certificate_start")}
        />
      </div>

      <div className="input-wrap pro-mb-4">
        <Input
          label={"Certificate End*"}
          type="text"
          id="certificate_end"
          name="certificate_end"
          className={`pro-input lg ${
            getFieldError("certificate_end") && " error"
          }`}
          {...formik.getFieldProps("certificate_end")}
          error={getFieldError("certificate_end")}
          errorMessage={getFieldError("certificate_end")}
        />
      </div>

      <div className="input-wrap pro-mb-4">
        <Input
          label={"Remark"}
          type="text"
          id="remark"
          name="remark"
          className={`pro-input lg ${getFieldError("remark") && " error"}`}
          {...formik.getFieldProps("remark")}
          error={getFieldError("remark")}
          errorMessage={getFieldError("remark")}
        />
      </div>

      {isImageMode ? (
        <div className="pro-mb-4 pro-w-100">
          <UploadPhoto
            previews={formik.values.images}
            handleChange={handleImagesChange}
            title={"Images*"}
            handleDeleteClick={handleImagesDelete}
            mutiple
            accept={".png,.jpeg,.jpg"}
            addText={"Add Images"}
            isError={!!getFieldError("images")}
            errorMsg={getFieldError("images")}
          />
        </div>
      ) : (
        <div className="input-wrap pro-mb-4">
          <label
            htmlFor="zip_file"
            className="pro-font-sm pro-mb-1 pro-fw-medium"
          >
            Zip File*
          </label>
          <input
            id="zip_file"
            type="file"
            accept=".zip"
            className={`pro-input lg ${getFieldError("zipFile") && " error"}`}
            onChange={handleZipChange}
          />
          {formik.values.zipFile?.name && (
            <span className="pro-font-sm pro-d-block pro-mt-1">
              {formik.values.zipFile.name}
            </span>
          )}
          {getFieldError("zipFile") && (
            <span className="error-text">{getFieldError("zipFile")}</span>
          )}
        </div>
      )}

      <div
        className={`col-12 pro-d-flex pro-justify-end pro-mt-5 offcanvas-footer-sticky-btn`}
      >
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className={`pro-btn-primary lg pro-ms-3 ${
            formik?.isSubmitting ? "loading" : ""
          }`}
          type="submit"
          disabled={formik?.isSubmitting}
          onClick={formik.handleSubmit}
        >
          {"Submit"}
        </Button>
      </div>
    </div>
  );
};

export default BulkUpload;
